import React from "react";
import { Grid, Typography, Button, CircularProgress } from "@mui/material";

function Footer({ handleSubmit, loader, formData, classes }) {
	return (
		<Grid container spacing={0} mt={1}>
			<Grid
				item
				alignContent="left"
				alignItems="left"
				xs={0}
				lg={9.5}
				xl={9.5}
				sm={0}
				sx={{ m: 1, justifyContent: "flex-start" }}
			>
				<Typography
					variant="h6"
					component="h6"
					ml={1}
					sx={{ fontSize: 14, display: "flex", justifyContent: "flex-start" }}
				>
					Already have an account?
					<Typography
						onClick={() => (window.location.href = "http://zuug.a-dmin.ai")}
						variant="h6"
						component="h6"
						ml={1}
						sx={{
							fontSize: 14,
							display: "flex",
							justifyContent: "flex-start",
							cursor: "pointer",
							textDecoration: "underline",
						}}
					>
						Sign In
					</Typography>
				</Typography>
			</Grid>
			<Grid
				item
				alignContent="right"
				alignItems="right"
				xs={12}
				lg={1.5}
				xl={1.5}
				sm={12}
				sx={{ m: 1, justifyContent: "flex-end" }}
			>
				{loader ? (
					<CircularProgress />
				) : (
					<Button
						variant="contained"
						className={classes.roundButton}
						onClick={() => handleSubmit()}
						disabled={
							formData?.email &&
							formData?.phone &&
							formData?.title &&
							formData?.firstName &&
							formData?.lastName &&
							formData?.ravsName &&
							formData?.prefereAge?.length &&
							formData?.singlesPlan?.length &&
							formData?.singlesType?.length &&
							formData?.experience
								? false
								: true
						}
					>
						Register
					</Button>
				)}
			</Grid>
		</Grid>
	);
}

export default Footer;
